import React from 'react';
import PropTypes from 'prop-types';
import ShowIf from './ShowIf';

export default class HideOnScroll extends React.Component {
  constructor(props) {
    super(props);
    const { defaultHide } = props;
    this.myRef = React.createRef();
    this.state = {
      hidden: defaultHide,
      scrollPos: 0,
    };
  }

  onScroll(element) {
    let currentScrollPos = element ? element.scrollTop : window.pageYOffset;
    const maxScroll = element ? element.scrollHeight - element.clientHeight : document.body.scrollHeight - window.innerHeight;
    const lastHidden = this.state.hidden;
    if (currentScrollPos !== this.state.scrollPos) {
      if (currentScrollPos > this.state.scrollPos) {
        currentScrollPos = lastHidden ? currentScrollPos : currentScrollPos - this.myRef.current.clientHeight;
        this.setState({ hidden: true, scrollPos: currentScrollPos });
        if (!lastHidden) this.props.onHideChange(true, this.myRef.current.clientHeight);
      } else {
        currentScrollPos = !lastHidden ? currentScrollPos : currentScrollPos + this.myRef.current.clientHeight;
        this.setState({ hidden: false, scrollPos: currentScrollPos });
        if (lastHidden) this.props.onHideChange(false, this.myRef.current.clientHeight);
      }
      // this.setState({ scrollPos: currentScrollPos });
    }
    /*
    // console.log(maxScroll)
    if (currentScrollPos > 0 && currentScrollPos < maxScroll) {
      debugger;

      this.setState({ hidden: true });
    } else {
      debugger;

      this.setState({ hidden: false });
    }
    */
  }

  componentDidMount() {
    const { target, hide } = this.props;
    if (hide) {
      this.setState({ hidden: true });
      this.props.onHideChange(true, 0);
    } else if (target) {
      const element = document.getElementById(target);
      document.getElementById(target).addEventListener('scroll', () => this.onScroll(element));
    } else if (typeof window !== 'undefined') {
      window.onscroll = () => this.onScroll();
    }
  }


  render() {
    const { children, hide } = this.props;
    const { hidden } = this.state;
    if (hide) return <></>;
    return (
      <div style={{
        position: 'relative', top: hide || hidden ? `-${this.myRef.current.clientHeight}px` : 0, transition: 'top 0.3s', zIndex: hide || hidden ? '-2' : '-1',
      }}
      >
        <div ref={this.myRef}>
          <div className="hideableBar">
            {children}
          </div>
        </div>
      </div>
    );
  }
}
HideOnScroll.propTypes = {
  defaultHide: PropTypes.bool,
  hide: PropTypes.bool,
  target: PropTypes.string,
  onHideChange: PropTypes.func,
};
HideOnScroll.defaultProps = {
  defaultHide: false,
  hide: false,
  target: null,
  onHideChange: () => {},
};
